// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noSize_ZFeD4.win_sPBDL.really_l1czl {
  height: unset;
  width: unset;
}

.emptyValue_ddnZv.win_sPBDL.really_l1czl {
  color : var( --color-base300 )
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/attributes/image/Renderer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE;AACF","sourcesContent":[".noSize.win.really {\n  height: unset;\n  width: unset;\n}\n\n.emptyValue.win.really {\n  color : var( --color-base300 )\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noSize": `noSize_ZFeD4`,
	"win": `win_sPBDL`,
	"really": `really_l1czl`,
	"emptyValue": `emptyValue_ddnZv`
};
export default ___CSS_LOADER_EXPORT___;
